'use client';

import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { useResponsive } from 'src/hooks/use-responsive';

import FaqsCategory from '../faqs/faqs-category';

export default function HomeSkills() {
  const mdUp = useResponsive('up', 'md');

  return (
    <Container
      sx={{
        py: { xs: 5, md: 10 },
      }}
    >
      {mdUp && (
        <Stack
          spacing={3}
          sx={{
            textAlign: 'center',
            mb: { xs: 5, md: 10 },
          }}
        >
          <Typography component="div" variant="overline" textAlign="center">
            Skills and Expertise
          </Typography>
        </Stack>
      )}

      <FaqsCategory />
    </Container>
  );
}
